"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHeaderConfigur = exports.getSearchRoadshow = exports.getColumnList = exports.getHomePageTypeList = exports.getHomePageMixedList = exports.getRoadshowBanner = exports.getRoadshowHomePage = void 0;
var apidata_1 = require("../apidata");
/**
 * api/Roadshow/HomePage
 * @returns
 */
var getRoadshowHomePage = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _url, opt, data, json, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                _url = "api/Roadshow/HomePage";
                opt = {
                    last_id: "",
                    count: 10,
                    sort: 1
                };
                data = __assign(__assign({}, opt), params);
                return [4 /*yield*/, (0, apidata_1.getLkApi2)(_url, data)];
            case 1:
                json = _a.sent();
                if (!(json && json.data)) {
                    return [2 /*return*/];
                }
                ;
                return [2 /*return*/, json.data];
            case 2:
                error_1 = _a.sent();
                return [2 /*return*/, []];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.getRoadshowHomePage = getRoadshowHomePage;
/**
 * banner
 * @returns
 */
var getRoadshowBanner = function () { return __awaiter(void 0, void 0, void 0, function () {
    var _url, json, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                _url = "api/roadshow/GetRoadshowBanner";
                return [4 /*yield*/, (0, apidata_1.getLkBanner2)(_url, {})];
            case 1:
                json = _a.sent();
                if (!(json && json.data)) {
                    return [2 /*return*/, []];
                }
                ;
                return [2 /*return*/, json.data];
            case 2:
                error_2 = _a.sent();
                return [2 /*return*/, []];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.getRoadshowBanner = getRoadshowBanner;
/**
 * 路演detail全部列表
 */
var getHomePageMixedList = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _url, opt, data, json, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                _url = "api/Roadshow/HomePageMixedList";
                opt = {
                    last_id: "",
                    count: 24,
                    sort: 1
                };
                data = __assign(__assign({}, opt), params);
                return [4 /*yield*/, (0, apidata_1.getLkApi2)(_url, data)];
            case 1:
                json = _a.sent();
                if (!(json && json.data)) {
                    return [2 /*return*/, []];
                }
                ;
                return [2 /*return*/, json];
            case 2:
                error_3 = _a.sent();
                return [2 /*return*/, []];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.getHomePageMixedList = getHomePageMixedList;
/**
 * 路演detail 子类列表
 */
var getHomePageTypeList = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _url, opt, data, json, error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                _url = "api/Roadshow/HomePageTypeList";
                opt = {
                    last_id: "",
                    count: 24,
                    sort: 1
                };
                data = __assign(__assign({}, opt), params);
                return [4 /*yield*/, (0, apidata_1.getLkApi2)(_url, data)];
            case 1:
                json = _a.sent();
                if (!(json && json.data)) {
                    return [2 /*return*/, []];
                }
                ;
                return [2 /*return*/, json];
            case 2:
                error_4 = _a.sent();
                return [2 /*return*/, []];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.getHomePageTypeList = getHomePageTypeList;
/**
 * column 栏目列表
 * @param params
 * @returns
 */
var getColumnList = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _url, opt, data, json, error_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                _url = "api/Column/HomeDetail";
                opt = {
                    sort: 1,
                    page: 1,
                    count: 12,
                    column_id: "",
                    column_name: '',
                    sub_column_id: ""
                };
                data = __assign(__assign({}, opt), params);
                return [4 /*yield*/, (0, apidata_1.getLkApi2)(_url, data)];
            case 1:
                json = _a.sent();
                if (!(json && json.data)) {
                    return [2 /*return*/, []];
                }
                ;
                return [2 /*return*/, json];
            case 2:
                error_5 = _a.sent();
                return [2 /*return*/, []];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.getColumnList = getColumnList;
/**
 * 财富视点搜索
 * @param params
 * @returns
 */
var getSearchRoadshow = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _url, opt, data, json, error_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                _url = "api/Search/Roadshow";
                opt = {
                    page: 1,
                    count: 12,
                    keyword: "",
                    source: 105 // 1007  105
                };
                data = __assign(__assign({}, opt), params);
                return [4 /*yield*/, (0, apidata_1.getLkApi2)(_url, data)];
            case 1:
                json = _a.sent();
                if (!(json && json.data)) {
                    return [2 /*return*/];
                }
                ;
                return [2 /*return*/, json];
            case 2:
                error_6 = _a.sent();
                return [2 /*return*/, []];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.getSearchRoadshow = getSearchRoadshow;
/**
 * 头部标签及二级标签配置
 * @param params
 * @returns
 */
var getHeaderConfigur = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _url, opt, data, json, error_7;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                _url = "api/Column/GetConfigurationV2023";
                opt = {};
                data = __assign(__assign({}, opt), params);
                return [4 /*yield*/, (0, apidata_1.getLkApi2)(_url, data)];
            case 1:
                json = _a.sent();
                if (!(json && json.data)) {
                    return [2 /*return*/];
                }
                ;
                return [2 /*return*/, json.data];
            case 2:
                error_7 = _a.sent();
                return [2 /*return*/, []];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.getHeaderConfigur = getHeaderConfigur;
//# sourceMappingURL=data:application/json;base64,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